<template>
  <v-app class="passion">
    <transition name="fade">
      <div id="main-wrap">
        <v-main>
          <div class="main-wrap">
            <!--<main-header></main-header>-->
            <slot v-slot:menu name="menu"/>
            <slot v-slot:header name="header"/>
            <section id="body">
              <slot v-slot:body name="body"/>
            </section>
            <div id="footer">
              <slot v-slot:footer name="footer"/>
            </div>
          </div>
        </v-main>
      </div>
    </transition>
  </v-app>
</template>

<style lang="scss" scoped>
  @import '../assets/vuetify-overide.scss';
  @import '../assets/transition.scss';
  @import '../assets/vendors/animate.css';
  @import '../assets/vendors/animate-extends.css';
  @import '../assets/vendors/hamburger-menu.css';

  .hide {
    display: none;
  }
  
  @function section-margin($margin) {
    @return $margin * 20;
  }
  .main-wrap {
    position: relative;
    width: 100%;
    overflow: hidden;
    .theme--dark & {
      background-color: $dark-background-default;
    }
    .theme--light & {
      background-color: $light-background-paper;
    }
  }
  .space-bottom {
    margin-bottom: section-margin(6px);
    @include breakpoints-down(sm) {
      margin-bottom: section-margin(3px);
    }
    @include breakpoints-down(xs) {
      margin-bottom: section-margin(2px);
    }
  }
  .space-bottom-short {
    margin-bottom: section-margin($spacing1 / 2);
  }
  .space-top {
    margin-top: section-margin(6px);
    @include breakpoints-down(sm) {
      margin-top: section-margin(3px);
    }
    @include breakpoints-down(xs) {
      margin-top: section-margin(2px);
    }
  }
  .space-top-short {
    margin-top: section-margin($spacing1 / 2);
    @include breakpoints-down(sm) {
      margin-top: section-margin(3px);
    }
    @include breakpoints-down(xs) {
      margin-top: section-margin(2px);
    }
  }
  .container-wrap {
    margin-top: -40px;
    > section {
      position: relative;
    }
  }
</style>

<script>
  export default {
  loading: false,
  data() {
    return {
      show: false
    }
  },
  mounted: function() {
    // Preloader and Progress bar setup
    this.show = true
    /*
    const preloader = document.getElementById('preloader')
    if (preloader !== null || undefined) {
      preloader.remove()
    }
    // RTL initial
    const rtlURL = document.location.pathname.split('/')[1] === 'ar'
    this.$vuetify.rtl = rtlURL
    */
  }
}
</script>
